/*
 *
 * QualitativeQuestionList constants
 *
 */

export const GET_QUALITATIVE_ANSWERS_WATCHER =
  "app/QualitativeQuestionList/GET_QUALITATIVE_ANSWERS_WATCHER"
export const GET_QUALITATIVE_ANSWERS_SUCCESS =
  "app/QualitativeQuestionList/GET_QUALITATIVE_ANSWERS_SUCCESS"
export const GET_QUALITATIVE_ANSWERS_FAILED =
  "app/QualitativeQuestionList/GET_QUALITATIVE_ANSWERS_FAILED"

export const GET_QUALITATIVE_ANSWERS_WORDCLOUD_WATCHER =
  "app/QualitativeQuestionList/GET_QUALITATIVE_ANSWERS_WORDCLOUD_WATCHER"
export const GET_QUALITATIVE_ANSWERS_WORDCLOUD_SUCCESS =
  "app/QualitativeQuestionList/GET_QUALITATIVE_ANSWERS_WORDCLOUD_SUCCESS"
export const GET_QUALITATIVE_ANSWERS_WORDCLOUD_FAILED =
  "app/QualitativeQuestionList/GET_QUALITATIVE_ANSWERS_WORDCLOUD_FAILED"

export const GET_QUALITATIVE_ANSWERS_SENTIMENT_WORDCLOUD_SUCCESS =
  "app/QualitativeQuestionList/GET_QUALITATIVE_ANSWERS_SENTIMENT_WORDCLOUD_SUCCESS"
